import { useEffect } from 'react';
import {
  setConversationInHash,
  markConversationAsEmpty,
  getEmptyConversationFromStorage,
  clearEmptyConversationFlag
} from '../utils/conversationUtils';

/**
 * Manages conversation persistence in URL hash and localStorage
 */
export const useConversationPersistence = (activeConversationId, messages) => {
  // Sync conversation ID to hash and localStorage
  useEffect(() => {
    if (activeConversationId) {
      localStorage.setItem('chat_lastActiveConversation', activeConversationId);
      
      // Mark as empty if this conversation has no messages
      if (messages.length === 0) {
        markConversationAsEmpty(activeConversationId);
      } else {
        // If this conversation has messages and is marked as empty, clear that flag
        const emptyConv = getEmptyConversationFromStorage();
        if (emptyConv === activeConversationId) {
          clearEmptyConversationFlag();
        }
      }
    }
  }, [activeConversationId, messages.length]);
  
  // Sync to hash when conversation becomes active
  useEffect(() => {
    if (activeConversationId) {
      setConversationInHash(activeConversationId);
      localStorage.setItem('chat_lastActiveConversation', activeConversationId);
    }
  }, [activeConversationId]);
};

